import TableCell from '@mui/material/TableCell';
import styles from './styles.module.css';
import TableRow from '@mui/material/TableRow';
import { FC } from 'react';
import { PriceData, UpdatePriceDto } from '../../types';
import { useRow } from './useRow';
import { Cell } from './components/Cell';
import { LoadingButton } from '@mui/lab';

interface RowProps {
  item: UpdatePriceDto;
  onSave:(data: PriceData) => Promise<void>;
}

export const Row: FC<RowProps> = ({item, onSave}) => {
  const {
    loading,
    oldPrice,
    price,
    isDisabled,
    oldPriceChange,
    priceChange,
    onSaveHdl
  } = useRow({ item, onSave });
  const {serviceId, nameEn} = item;
  return (
    <TableRow
      className={styles.row}
      key={serviceId}
      sx={{ '& > *': { borderBottom: 'unset' } }}
    >
      <TableCell align="left" component="th" scope="row">
        {nameEn}
      </TableCell>
      <Cell price={oldPrice} onChange={oldPriceChange} />
      <Cell price={price} onChange={priceChange}/>
      <TableCell align="right">
          <LoadingButton
            disabled={isDisabled}
            variant="contained"
            loading={loading}
            onClick={onSaveHdl}
          >
            SAVE
          </LoadingButton>
      </TableCell>
    </TableRow>
  )
}